import { useState } from 'react'
import { apiFetch } from '../lib/api'
import { defaultProfileForm, inputCls } from '../lib/constants'
import ProfileFields from './ProfileFields'

export default function ProfileCompletionModal({ onClose, onCompleted, gpsCity }) {
  const [form, setForm]       = useState({ ...defaultProfileForm, city: gpsCity || defaultProfileForm.city })
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState('')

  async function handleSubmit() {
    const birthYearNum = Number(form.birthYear)
    const currentYear = new Date().getFullYear()
    if (!form.bio.trim()) { setError('Bio is required.'); return }
    if (!form.profilePicture.trim()) { setError('Profile picture is required.'); return }
    if (!form.city.trim()) { setError('City is required.'); return }
    if (!form.area.trim()) { setError('Area / neighbourhood is required.'); return }
    if (!form.gender) { setError('Gender is required.'); return }
    if (!form.whoWillPay) { setError('Who will pay is required.'); return }
    if (!Number.isInteger(birthYearNum) || birthYearNum < 1900 || birthYearNum > currentYear - 13) { setError('Enter a valid birth year.'); return }
    setLoading(true)
    try {
      const interests = form.interestsInput.split(',').map(s => s.trim()).filter(Boolean)
      const res = await apiFetch('/auth/complete-profile', {
        method: 'POST',
        body: JSON.stringify({
          bio: form.bio, profilePicture: form.profilePicture,
          gender: form.gender,
          birthYear: birthYearNum,
          location: { address: form.address, city: form.city, area: form.area },
          preferences: {
            dietaryType: form.dietaryType,
            budgetVibe: form.budgetVibe,
            whoWillPay: form.whoWillPay,
            interests,
          },
          availability: { isAvailable: form.isAvailable, label: form.availabilityLabel }
        })
      })
      const data = await res.json()
      if (!res.ok) { setError(data.message); return }
      onCompleted(data)
    } catch { setError('Network error.') }
    finally { setLoading(false) }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="glass-card w-full max-w-md rounded-3xl border border-white/60 p-8 shadow-2xl fade-up overflow-y-auto max-h-[95vh]">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="title-font text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Almost there!</p>
            <h2 className="title-font text-2xl font-bold text-gray-900 mt-0.5">Complete your profile</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-2xl">✕</button>
        </div>
        <p className="text-sm text-gray-600 mb-5">Help us find your best dining matches by telling us a bit about yourself.</p>
        {error && <div className="mb-4 rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">{error}</div>}
        <ProfileFields form={form} setForm={setForm} />
        <p className="mt-5 text-xs leading-5 text-gray-500">
          By tapping Submit, you agree to create an account and to CoEater's{' '}
          <a href="/terms-of-use" target="_blank" rel="noreferrer" className="font-semibold text-orange-600 hover:underline">Terms of Use</a>
          {' '}and{' '}
          <a href="/privacy-policy" target="_blank" rel="noreferrer" className="font-semibold text-orange-600 hover:underline">Privacy Policy</a>
          .
        </p>
        <button onClick={handleSubmit} disabled={loading}
          className="mt-6 w-full rounded-full bg-gradient-to-r from-red-500 to-orange-500 py-3 text-sm font-bold text-white hover:from-red-600 hover:to-orange-600 disabled:opacity-50 transition">
          {loading ? 'Saving…' : '🎉 Complete Profile'}
        </button>
      </div>
    </div>
  )
}
